/***********
 * 优秀案例
 **************/
const columns = [{
  title: "序号",
  dataIndex: "sortIndex",
  key: "sortIndex",
  width: 80,
  scopedSlots: {
    customRender: "sortIndex"
  }
}, {
  title: "优秀案例名称",
  dataIndex: "file_name",
  key: "file_name",
  ellipsis: true
}, {
  title: "上传人",
  dataIndex: "create_user_name",
  key: "create_user_name",
  width: 80
}, {
  title: "上传日期",
  dataIndex: "update_time",
  key: "update_time"
}, {
  title: "操作",
  dataIndex: "action",
  key: "action",
  width: 100,
  scopedSlots: {
    customRender: "action"
  }
}];
export default {
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    },
    caseList: {
      type: Array
    }
  },

  data() {
    return {
      columns // caseList: [],

    };
  },

  // watch: {
  //   laboratoryItemDetail(newval, oldval) {
  //     if (newval) {
  //       this.getCaseList(newval.id);
  //     }
  //   },
  // },
  methods: {
    // async getCaseList(vr_id) {
    //   const data = await this.$get("/34-getVRCasePageByParam/union-vr", {
    //     vr_id: vr_id,
    //   });
    //   this.caseList = data.content;
    // },
    hrefdetail(text, record) {
      window.open(record.file_url, "_blank");
    }

  }
};